module.exports = __webpack_public_path__ + "static/notch-logo-269cf2f0a7342e05f626a60aa6bb357c.png";